"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _LegendItem = _interopRequireDefault(require("./LegendItem"));
var _Legend2 = _interopRequireDefault(require("./Legend.style"));
var _LegendPagination = _interopRequireDefault(require("./LegendPagination"));
var _excluded = ["items", "labelKey", "colors", "accentColor", "currency", "pageSize", "activeIndex", "highlightRow", "removeHighlight", "highlightActive", "onItemClick", "prefixId", "idKey", "withPagination", "withDescription", "withTextValue"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Legend = /*#__PURE__*/function (_Component) {
  function Legend(props) {
    var _this;
    _classCallCheck(this, Legend);
    _this = _callSuper(this, Legend, [props]);
    _defineProperty(_this, "nextPage", function () {
      _this.setState(function (prevState) {
        return {
          currentPage: prevState.currentPage + 1
        };
      });
    });
    _defineProperty(_this, "previousPage", function () {
      _this.setState(function (prevState) {
        return {
          currentPage: prevState.currentPage - 1
        };
      });
    });
    _this.state = {
      currentPage: 1
    };
    return _this;
  }
  _inherits(Legend, _Component);
  return _createClass(Legend, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        items = _this$props.items,
        labelKey = _this$props.labelKey,
        colors = _this$props.colors,
        accentColor = _this$props.accentColor,
        currency = _this$props.currency,
        pageSize = _this$props.pageSize,
        activeIndex = _this$props.activeIndex,
        highlightRow = _this$props.highlightRow,
        removeHighlight = _this$props.removeHighlight,
        highlightActive = _this$props.highlightActive,
        onItemClick = _this$props.onItemClick,
        prefixId = _this$props.prefixId,
        idKey = _this$props.idKey,
        withPagination = _this$props.withPagination,
        withDescription = _this$props.withDescription,
        withTextValue = _this$props.withTextValue,
        otherProps = _objectWithoutProperties(_this$props, _excluded);
      var currentPage = this.state.currentPage;
      var pages = Math.ceil(items.length / pageSize);
      var hasPagination = withPagination && pages > 1;
      var currentItems = withPagination ? items.slice((currentPage - 1) * pageSize, currentPage * pageSize) : items;
      return /*#__PURE__*/_react["default"].createElement(_Legend2["default"], _extends({
        id: prefixId ? "".concat(prefixId, "_legend") : 'legend',
        itemsCount: currentItems.length,
        accentColor: accentColor,
        hasPagination: hasPagination
      }, otherProps), currentItems.map(function (item, idx) {
        return /*#__PURE__*/_react["default"].createElement(_LegendItem["default"], {
          highlightRow: highlightRow,
          currency: item.template === 'percentage' ? '%' : item.currencyCode || currency,
          onMouseOver: _this2.props.highlightActive && function () {
            return _this2.props.highlightActive(item);
          },
          onFocus: _this2.props.highlightActive && function () {
            return _this2.props.highlightActive(item);
          },
          id: prefixId ? "".concat(prefixId, "LegendItem").concat(idx) : "legendItem".concat(idx),
          onMouseOut: _this2.props.removeHighlight && function () {
            return _this2.props.removeHighlight(item);
          },
          onBlur: _this2.props.removeHighlight && function () {
            return _this2.props.removeHighlight(item);
          },
          onClick: onItemClick(item[idKey]),
          label: item[labelKey] || '',
          value: item.isNegative ? -item.value : item.value,
          textValue: withTextValue && !item.isAmount ? item.text : '',
          description: withDescription && item.rewardDescription ? item.rewardDescription : '',
          percent: item.percentage,
          boxColor: colors && colors[(currentPage - 1) * pageSize + idx],
          key: item[idKey],
          active: activeIndex === item.orderIndex,
          template: item.template,
          isAmount: item.isAmount || item.template === 'percentage'
        });
      }), hasPagination && /*#__PURE__*/_react["default"].createElement(_LegendPagination["default"], {
        id: prefixId ? "".concat(prefixId, "LegendPagination") : 'legendPagination',
        nextPage: currentPage < pages && this.nextPage,
        previousPage: currentPage > 1 && this.previousPage
      }));
    }
  }]);
}(_react.Component);
Legend.defaultProps = {
  labelKey: 'label',
  pageSize: 5,
  currency: 'EUR',
  activeIndex: -1,
  highlightRow: false,
  highlightActive: function highlightActive() {},
  removeHighlight: function removeHighlight() {},
  colors: null,
  accentColor: null,
  onItemClick: function onItemClick() {},
  prefixId: null,
  withPagination: false,
  withDescription: true,
  withTextValue: false
};
Legend.propTypes = {
  idKey: _propTypes["default"].string.isRequired,
  /** items to display in the legend */
  items: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired,
  /** Name of the label key of the data */
  labelKey: _propTypes["default"].string,
  /** array of colors to use for the color box of the legend items */
  colors: _propTypes["default"].arrayOf(_propTypes["default"].string),
  /** the color to use for various stying purposes */
  accentColor: _propTypes["default"].string,
  /** number of items to display per page */
  pageSize: _propTypes["default"].number,
  /** prefix the item id's */
  prefixId: _propTypes["default"].string,
  /** currency to display value with */
  currency: _propTypes["default"].string,
  /** index of the selected item in the legend */
  activeIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].shape({})]),
  /** if active, the LegendItem row will be highlighted on mouseenter */
  highlightRow: _propTypes["default"].bool,
  /** callback to update the selected index */
  highlightActive: _propTypes["default"].func,
  /** callback to reset the selected index */
  removeHighlight: _propTypes["default"].func,
  /** action on item click */
  onItemClick: _propTypes["default"].func,
  /** if active, the LegendPagination will be rendered */
  withPagination: _propTypes["default"].bool,
  /** if active, the description of the item will be rendered */
  withDescription: _propTypes["default"].bool,
  /** if active, the value of the a text only item will be rendered */
  withTextValue: _propTypes["default"].bool
};
var _default = exports["default"] = Legend;